import { useQuery } from '@tanstack/react-query'

import { getOnboardingRequests } from '@src/api'
import { DefaultApiGetOnboardingRequestsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchOnboardingRequests = (
  params: DefaultApiGetOnboardingRequestsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    queryFn: () => getOnboardingRequests(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ZEUS_ONBOARDING_REQUESTS, params],
  })
}
